import type { Arm, NavImpactSurfaces } from '../arms';

import { spec as v1DeltaChips } from './v1_delta_chips';
import { spec as v2PlainCountsStacked } from './v2_plain_counts_stacked';
import { spec as v3PlainCountsInline } from './v3_plain_counts_inline';
import { spec as v4TrendIcons } from './v4_trend_icons';

export type ArmSpec = () => Partial<NavImpactSurfaces>;

export const ARMS: Partial<Record<Arm, ArmSpec>> = {
  v1_delta_chips: v1DeltaChips,
  v2_plain_counts_stacked: v2PlainCountsStacked,
  v3_plain_counts_inline: v3PlainCountsInline,
  v4_trend_icons: v4TrendIcons,
};
